import { ChartData } from 'chart.js';
import React from 'react';
import { Line } from 'react-chartjs-2';

import { Formatters } from 'app/utils/formatters';

interface MetricsGraphProps {
    label: string;
    x: string;
    y: string;
    data: unknown[];
}

export class MetricsGraph extends React.Component<MetricsGraphProps> {
    public render(): React.ReactNode {
        const data = this.fetchData();

        return <Line height={80} data={data} />;
    }

    private fetchData(): ChartData<'line'> {
        const labels: string[] = [];
        const data: number[] = [];

        this.props.data.forEach((row) => {
            const roxX = row as Record<string, unknown>;
            labels.push(Formatters.date(roxX[this.props.x] as string));
            data.push(roxX[this.props.y] as number);
        });

        return {
            labels,
            datasets: [
                {
                    label: this.props.label,
                    data,
                    borderColor: 'rgb(75, 192, 192)',
                    tension: 0.2,
                },
            ],
        };
    }
}
